import { Service } from '@toeverything/infra';

import type { WorkspaceService } from '../../workspace';
import { MemberSearchSession } from '../session/member-search-session';
import type { MemberSearchStore } from '../stores/member-search';

/**
 * Factory for per-consumer MemberSearchSession instances.
 *
 * Each consumer that needs paginated/searchable member access creates its own
 * session via `createSession()` and disposes it when finished. Per-consumer
 * sessions prevent the cross-consumer state-thrash that occurred when this
 * service held workspace-scoped pagination state directly.
 */
export class MemberSearchService extends Service {
  constructor(
    private readonly store: MemberSearchStore,
    private readonly workspaceService: WorkspaceService
  ) {
    super();
  }

  createSession(): MemberSearchSession {
    return new MemberSearchSession(
      this.store,
      this.workspaceService.workspace.id
    );
  }
}

export { MemberSearchSession };
